import { render, staticRenderFns } from "./VIPKalameetingDetails.vue?vue&type=template&id=4355875c&"
import script from "./VIPKalameetingDetails.vue?vue&type=script&lang=js&"
export * from "./VIPKalameetingDetails.vue?vue&type=script&lang=js&"
import style0 from "./VIPKalameetingDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports